export enum PAYMENTS_AGGREGATOR_ID {
  PLATRON = 1,
  ALIKASSA = 2,
  PAYMENT_CENTER = 4,
  XPATE = 5,
  MPSPAY = 6,
  SOLIDGATE = 8,
  BTRKASSA = 9,
  POWER_CASH = 10,
  SAFECHARGE = 11,
  CYPIX = 12,
  CCBILL = 13,
  ROCKETGATE = 14,
  SMART_PAY = 15,
  PAY_LINK = 16,
  BTRKASSA_P2P = 17,
  VEPAY = 18,
  SOFTPAY = 19,
  A_WALLET = 20,
  CYPIX_SBP = 21,
  BLUE_WHALE = 22,
  SOFT_PAY_SBP = 23,
  PAY_SELECTION_SBP = 24,
  OVERPAY = 25,
}

export enum PAYMENTS_PAYMENT_SYSTEM_ID {
  CREDIT_CARD = 1,
  QIWI = 2,
  TEST_CARD = 4,
  GOOGLE_PAY = 7,
  CRYPTO = 8,
  SBP = 9,
  MIR = 100,
}

export enum PAYMENTS_PAYMENT_SYSTEM_STATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum PAYMENTS_AGGREGATOR_STATE {
  ENABLED = 'enabled',
  DISABLED = 'disabled',
}

export enum PAYMENT_STATUS {
  OPENED = 1,
  PAYED = 2,
  REJECTED = 3,
  FAILED = 4,
  AWAITING_CONFIRMATION = 5,
}
